
export default {
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
};
